import {
  AiAssistantEditModel,
  MyAssitantListItem,
} from '../models/AI/AiAssistantModels';
import {ApiResponse} from '../models/ApiResponse';
import {apiClient} from './baseApiClient';
import {BASE_URL} from './config';

class AiAssitantsApi {
  public getMyAssistants(
    courseId?: string,
  ): Promise<ApiResponse<MyAssitantListItem[]>> {
    if (courseId) {
      return apiClient.get(`/AiAssistant/my_assistants?courseId=${courseId}`);
    }
    return apiClient.get(`/AiAssistant/my_assistants`);
  }

  public clearAiAssistantChat(assistantid: string): Promise<ApiResponse<any>> {
    return apiClient.post(`/AiAssistant/clear_history/${assistantid}`);
  }
  public clearAiAssistantPublicChat(
    assistantid: string,
    sessionId: string,
  ): Promise<ApiResponse<any>> {
    //return apiClient.post(`/AiAssistant/clear_history/${assistantid}`);
    return apiClient.post(
      `/AiAssistant/public/clear_history/${assistantid}?sessionId=${sessionId}`,
    );
  }

  public getAssitantForEditing(
    organicationId: string,
    assistantId: string,
  ): Promise<ApiResponse<AiAssistantEditModel>> {
    return apiClient.get(
      `/videoQuestions/${organicationId}/ai_assistant/${assistantId}`,
    );
  }

  public async sendAssistantChatStream(
    organizationId: string,
    assistantId: string,
    question: string,
    onChunk: (chunk: string) => void,
    onError?: (error: string) => void,
  ): Promise<void> {
    const response = await fetch(
      `${BASE_URL}/AiAssistant/${organizationId}/ai_assistant/chat_stream`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          question,
          assistantId,
        }),
      },
    );

    await this.readSseStream(response, onChunk, onError);
  }

  public async sendAssistantPublicChatStream(
    organizationId: string,
    assistantId: string,
    sessionId: string,
    question: string,
    onChunk: (chunk: string) => void,
    onError?: (error: string) => void,
  ): Promise<void> {
    const response = await fetch(
      `${BASE_URL}/AiAssistant/${organizationId}/public/ai_assistant/chat_stream`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          question,
          assistantId,
          sessionId,
        }),
      },
    );

    await this.readSseStream(response, onChunk, onError);
  }

  private async readSseStream(
    response: Response,
    onChunk: (chunk: string) => void,
    onError?: (error: string) => void,
  ): Promise<void> {
    if (!response.ok) {
      const errorText = await response.text();
      onError?.(errorText || 'Stream request failed');
      return;
    }

    const reader = response.body?.getReader();
    if (!reader) {
      onError?.('No response body');
      return;
    }

    const decoder = new TextDecoder();
    let isDone = false;

    while (!isDone) {
      const {done, value} = await reader.read();
      isDone = done;

      if (value) {
        const text = decoder.decode(value, {stream: true});
        const lines = text.split('\n');

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const chunk = line.substring(6);
            if (chunk) {
              onChunk(chunk);
            }
          }
        }
      }
    }
  }
}

export default AiAssitantsApi;
